"use client";

var __jsx = React.createElement;
import { BREAKPOINTS } from "@lib/constants";
import { useTranslations } from "next-intl";
import React, { createContext, useContext, useState } from "react";
import { useMediaQuery } from "react-responsive";
const ModalMessagesContext = /*#__PURE__*/createContext(null);
export const ModalMessagesProvider = _ref => {
  let {
    children
  } = _ref;
  const t = useTranslations();
  const {
    0: modalIsOpen,
    1: setModalIsOpen
  } = useState(false);
  const {
    0: modalProps,
    1: setModalProps
  } = useState({});
  const isMobile = useMediaQuery({
    query: "(max-width: ".concat(BREAKPOINTS.md, "px)")
  });
  const showModalMessage = messageModalProps => {
    setModalProps(messageModalProps);
    setModalIsOpen(true);
  };
  const showYesNoModal = (title, message, onYes, onNo) => {
    setModalProps({
      title,
      message,
      closeable: true,
      actions: [{
        text: t("Shared.Actions.YES"),
        onClick: onYes,
        buttonVariant: isMobile ? "solidXL" : "solidMd"
      }, {
        text: t("Shared.Actions.NO"),
        onClick: () => {
          setModalIsOpen(false);
          onNo === null || onNo === void 0 || onNo();
        },
        buttonVariant: isMobile ? "outlineXL" : "outlineMd"
      }]
    });
    setModalIsOpen(true);
  };
  return __jsx(ModalMessagesContext.Provider, {
    value: {
      showModalMessage,
      modalIsOpen,
      setModalIsOpen,
      modalProps,
      showYesNoModal
    }
  }, children);
};
export const useModalMessages = () => {
  const context = useContext(ModalMessagesContext);
  if (context === null) {
    throw new Error("useModalMessages must be used within a ModalMessagesProvider");
  }
  return context;
};